import React from 'react'

export default props => (
    <svg width="20" height="20" viewBox="0 0 24 24" {...props}>
        <path d="M9.646 4.15a2.752 2.752 0 0 1 4.708 0l7.771 12.975a2.75 2.75 0 0 1-2.36 4.125H4.224a2.75 2.75 0 0 1-2.343-4.138L9.646 4.151zM3.462 18.043a.917.917 0 0 0 .774 1.375h15.518a.917.917 0 0 0 .791-1.363L12.784 5.097a.917.917 0 0 0-1.567-.002L3.462 18.042zm7.621-8.709a.917.917 0 0 1 1.834 0V13a.917.917 0 0 1-1.834 0V9.333zm.917 8.25a.917.917 0 1 1 0-1.833.917.917 0 0 1 0 1.833z" />
    </svg>
)
